module.exports = "/pages/google/Common/Foodslabo/Simple/fv_background_image.png";